import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ClipLoader } from 'react-spinners';

import {
  Grid,
  Stack,
  Button,
  Tooltip,
  Box,
} from '@mui/material';

import styles from './actions-section.module.scss';

interface ActionsSectionProps {
  gameBuild?: any; // Используем any для совместимости с разными типами GameBuild
  gameBuildCreationLoading: boolean;
  isReadOnly: boolean;
  onTestGameClick: () => void;
  hasErrors?: boolean;
  onBeforeSubmit?: () => void;
}

const ActionsSection: FC<ActionsSectionProps> = ({
  gameBuild,
  gameBuildCreationLoading,
  isReadOnly,
  onTestGameClick,
  hasErrors = false,
  onBeforeSubmit,
}) => {
  const { t } = useTranslation();



  return (
    <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
      <Stack direction="row" spacing={2} alignItems="center">
                        <Tooltip title={t('clientAll.createGameTooltip')} arrow placement="top" enterTouchDelay={0} leaveTouchDelay={3000}>
                  <Button
                    type="submit"
                    variant="contained"
                    className={`${styles.submitButton} ${hasErrors ? styles.submitButtonError : ''}`}
                    disabled={gameBuildCreationLoading || isReadOnly}
                    aria-invalid={hasErrors ? true : undefined}
                    onClick={onBeforeSubmit}
                    sx={{
                      ...(hasErrors && {
                        '&:hover': { boxShadow: '0 0 20px rgba(239, 68, 68, 0.4)' },
                        animation: 'pulse 2s infinite',
                        '@keyframes pulse': {
                          '0%': { boxShadow: '0 0 0 0 rgba(239, 68, 68, 0.7)' },
                          '70%': { boxShadow: '0 0 0 10px rgba(239, 68, 68, 0)' },
                          '100%': { boxShadow: '0 0 0 0 rgba(239, 68, 68, 0)' },
                        },
                      }),
                    }}
                  >
                    {gameBuildCreationLoading ? <ClipLoader size={20} color="#ffffff" /> : t('clientAll.createGame')}
                  </Button>
                </Tooltip>

        {gameBuild && (
          <Button
            variant="outlined"
            onClick={onTestGameClick}
            className={styles.testGameButton}
          >
            {t('clientAll.testGame')}
          </Button>
        )}
      </Stack>
    </Box>
  );
};

export default ActionsSection; 